export const ROUTES = {
  CHANNEL_REDIRECT: '/channel-redirect',
  CONDITION_CHECK: '/condition-check',
  DOCUMENT_SIGNING: '/document-signing',
  DOCUMENT_UPLOAD: '/document-upload',
  FORGOT_PASSWORD: '/forgot-password',
  SEARCH: '/search',
  SIGN_IN: '/login',
  SUBSCRIPTION_CONFIRMATION: '/subscription-confirmation',
  SUBSCRIPTION_SETTINGS: '/subscription-settings',
  UNAUTHORIZED: '/unauthorized',
  WORKSPACE_BROADCASTS: (envy: string) => getWorkspaceUrl(envy, 'broadcasts'),
  WORKSPACE_CHANNEL_BROWSER: (envy: string) => getWorkspaceUrl(envy, 'channel-browser'),
  WORKSPACE_CONFIGURATIONS: (envy: string) => getWorkspaceUrl(envy, 'configurations'),
  WORKSPACE_CONTACT_GROUPS: (envy: string) => getWorkspaceUrl(envy, 'contact-groups'),
  WORKSPACE_CONTACTS: (envy: string) => getWorkspaceUrl(envy, 'contacts'),
  WORKSPACE_EXTERNAL_CHANNELS: (envy: string) => getWorkspaceUrl(envy, 'channels/external'),
  WORKSPACE_FEATURE_UPDATES: (envy: string) => getWorkspaceUrl(envy, 'feature-updates'),
  WORKSPACE_GLOBAL_SEARCH: (envy: string) => getWorkspaceUrl(envy, 'search'),
  WORKSPACE_IMPORT_CONTACTS: (envy: string) => getWorkspaceUrl(envy, 'import-contacts'),
  WORKSPACE_INTERNAL_CHANNELS: (envy: string) => getWorkspaceUrl(envy, 'channels/internal'),
  WORKSPACE_LANDING_REDIRECT: '/workspace/landing-redirect',
  WORKSPACE_PROFILE: (envy: string) => getWorkspaceUrl(envy, 'profile'),
  WORKSPACE_RESPONSES: (envy: string) => getWorkspaceUrl(envy, 'responses'),
  WORKSPACE_SETTINGS: (envy: string) => getWorkspaceUrl(envy, 'settings'),
  WORKSPACE_SUPPORT: (envy: string) => getWorkspaceUrl(envy, 'support'),
  WORKSPACE_TEAM: (envy: string) => getWorkspaceUrl(envy, 'team'),
  WORKSPACE_USAGE_REPORT: (envy: string) => getWorkspaceUrl(envy, 'usage'),
  WORKSPACE_VENDOR_BROWSER: (envy: string) => getWorkspaceUrl(envy, 'contact-browser'),
  /** @deprecated */
  WORKSPACE_DEPRECATED_EXTERNAL_CHANNELS: '/workspace/channels/external', // we need to handle this until we move our native app off this URL
}

function getWorkspaceUrl(envy: string, subpath: string) {
  return `/workspace/${envy}/${subpath}`
}

export const NO_AUTH_ROUTES = [ROUTES.SIGN_IN, ROUTES.FORGOT_PASSWORD]
